module.exports = __webpack_public_path__ + "img/product-1-back-MOBILE.e6efd526.png";